import { MouseEvent, useState } from 'react'
import { useIntl } from 'react-intl'

import { KTIcon } from '../../../../_metronic/helpers'
import { SmartTooltip } from '../../../../components/SmartTooltip/SmartTooltip'
import { convertUTCtoMSK, truncateByWords } from '../../../../utils'
import { AuditLogLink } from '../../Logs/routes/Audit/components/AuditLogLink'
import { CashBoxAttempts, CashBoxAttemptsToggle } from '../../ticket-card/components/CashBoxAttempts'
import { isCashBoxRow } from '../../ticket-card/core/cashBoxAttempts.types'
import { Transaction } from '../core/_models'
import styles from './FinishedTicketItem.module.css'

// Toggle, adapter id, created, closed, status, adapter, requisite name, reason, hint, audit link.
const TRANSACTION_COLUMNS = 10

type Props = {
  transaction: Transaction
  showRequisiteName: boolean
  onCopy: (e: MouseEvent) => void
}

/** One adapter transaction of a finished deposit; the local one expands into its cassa attempts. */
export const FinishedTicketTransactionRow = ({ transaction, showRequisiteName, onCopy }: Props) => {
  const intl = useIntl()
  const [attemptsOpen, setAttemptsOpen] = useState(false)
  const hasAttempts = Boolean(transaction.cashBoxAttempts && transaction.cashBoxAttempts.length > 0)

  return (
    <>
      <tr>
        <td>
          {hasAttempts && (
            <CashBoxAttemptsToggle
              isOpen={attemptsOpen}
              onToggle={() => setAttemptsOpen((prev) => !prev)}
            />
          )}
        </td>
        <td
          className={transaction.paymentId && styles.transactionId}
          onClick={transaction.paymentId ? onCopy : () => {}}
        >
          {transaction.paymentId || '-'}
        </td>
        <td>{convertUTCtoMSK(transaction?.createdAt)}</td>
        <td>{(transaction?.completedAt && convertUTCtoMSK(transaction?.completedAt)) || '-'}</td>
        <td>
          {intl.formatMessage({
            id: `transaction.status.${transaction.status}` || '-',
          })}
        </td>
        <td>{transaction.paymentAdapter || '-'}</td>
        {showRequisiteName && <td>{transaction?.requisiteName || '-'}</td>}
        <td>{transaction?.error || '-'}</td>
        <td>
          {transaction?.errorRaw != null && (
            <SmartTooltip content={truncateByWords(transaction.errorRaw, 250)}>
              <span
                style={{
                  display: 'inline-flex',
                  minWidth: '25px',
                  justifyContent: 'center',
                  cursor: 'help',
                  userSelect: 'none',
                  padding: 0,
                  border: '0px',
                }}
              >
                <KTIcon className={`fs-1 text-danger`} iconName='information-5' />
              </span>
            </SmartTooltip>
          )}
        </td>
        <td className='text-end'>
          {!isCashBoxRow(transaction) && <AuditLogLink paymentId={transaction.paymentId} />}
        </td>
      </tr>
      {hasAttempts && attemptsOpen && (
        <tr>
          <td colSpan={TRANSACTION_COLUMNS}>
            <CashBoxAttempts attempts={transaction.cashBoxAttempts} />
          </td>
        </tr>
      )}
    </>
  )
}
